export default {
    data() {
        return {
            notificationType: {
                success: {
                    icon: 'mdi mdi-check-circle-outline',
                    variant: 'success'
                },
                error: {
                    icon: 'mdi mdi-close-circle-outline',
                    variant: 'danger'
                },
                info: {
                    icon: 'mdi mdi-information-outline',
                    variant: 'primary'
                },
                warning: {
                    icon: 'mdi mdi-alert',
                    variant: 'warning'
                }
            }
        }
    },
}
